export default "__VITE_ASSET__9777c190__"